import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "receipt-check-2, ticket" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M7.62484 12.2915H13.0415M8.56234 7.91651L9.88178 9.23596L12.5207 6.59708M5.95817 2.2915H14.7082C15.6286 2.2915 16.3748 3.0377 16.3748 3.95817V17.7082L14.2221 15.8332L12.2776 17.7082L10.3332 15.8332L8.38873 17.7082L6.44428 15.8332L4.2915 17.7082V3.95817C4.2915 3.0377 5.0377 2.2915 5.95817 2.2915Z",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }